/**
 * @description
 * - Maintains a single application object at a time.
 * - Any operation specific to one application that needs to broadcast an update after it resolves should be called from here.
 * - Provides an onChange method
 */
;(function () {
  'use strict'

  angular
    .module('contrast.current-application')
    .factory('CurrentApplicationService', CurrentApplicationService)

  function CurrentApplicationService(
    $q,
    $rootScope,
    CURRENT_APPLICATION_EVENTS,
    ApplicationService,
    ORGANIZATION_SWITCH_EVENT
  ) {
    'ngInject'

    var _loaded,
      _model = {},
      deregisterEnvironmentUpdatedListener,
      deregisterOrganizationSwitchedListener

    var service = {
      init: init,
      get: get,
      onChange: onChange
    }

    return service

    function _getApplicationId() {
      return _model.applicationId
    }

    /**
     * @description
     * - Call this from the code point (probably a controller) that will need the application data first.
     * - Any other controllers can just listen with onChange.
     */
    function init(applicationId) {
      _loaded = false
      _model.applicationId = applicationId
      _initEnvironmentUpdatedListener()
      _initOrganizationSwitchedListener()
      return get()
    }

    /**
     * @description Returns the current application object
     */
    function get(breakCache) {
      if (breakCache || !_loaded) {
        return ApplicationService.get(_getApplicationId()).then(function (
          application
        ) {
          _model.application = application
          _loaded = true
          return _model.application
        })
      } else {
        return $q.when(_model.application)
      }
    }

    /**
     * Functions that will broadcast an update for all onChange listeners
     */

    /**
     * Event related functions
     */

    function onChange(cb) {
      // TODO: CONTRAST-18296
      // eslint-disable-next-line angular/on-watch
      return $rootScope.$on(
        CURRENT_APPLICATION_EVENTS.APPLICATION_CHANGE,
        function () {
          get(true).then(cb)
        }
      )
    }

    function _broadcast() {
      $rootScope.$broadcast(
        CURRENT_APPLICATION_EVENTS.APPLICATION_CHANGE,
        _model.application
      )
    }

    function _initEnvironmentUpdatedListener() {
      if (angular.isFunction(deregisterEnvironmentUpdatedListener)) {
        deregisterEnvironmentUpdatedListener()
      }
      deregisterEnvironmentUpdatedListener = $rootScope.$on(
        'environment:updated',
        function () {
          get(true).then(_broadcast)
        }
      )
    }

    function _initOrganizationSwitchedListener() {
      if (angular.isFunction(deregisterOrganizationSwitchedListener)) {
        deregisterOrganizationSwitchedListener()
      }

      deregisterOrganizationSwitchedListener = $rootScope.$on(
        ORGANIZATION_SWITCH_EVENT,
        function () {
          _model = {}
        }
      )
    }
  }
})()
